import { styled } from '@fluentui/react';
import { InfoToggleBase } from './InfoToggle.base';
import { getStyles } from './InfoToggle.styles';
import { IInfoToggleProps, IInfoToggleStyleProps, IInfoToggleStyles } from './InfoToggle.types';

export const InfoToggle = styled<IInfoToggleProps, IInfoToggleStyleProps, IInfoToggleStyles>(InfoToggleBase, getStyles, undefined, {
  scope: 'InfoToggle',
});
